import { CaseScreening } from './caseScreening';
import { Injectable } from '@angular/core';
import { Adapter } from './../interfaces/adapter';
import { UserAdapter } from './user.model';
import { PhoneConversation } from './phoneConversation';
import { CaseStakeholder } from './caseStakeholder';
import { SimpleCaseStakeholder } from './simpleCaseStakeholder';
import { SimpleIncident } from './SimpleIncident';
import { ChannelType } from './enumerations/channelType';
import { StakeholderTypeEnum } from './enumerations/stakeholder-type.enum';
import { HandlingArea, HandlingAreaAdapter } from '@supoui/shared/model/handling-area';

export class Case {
  team: string;
  cu: string;
  product: string;
  id: string;
  endUserName: string;
  sex: string;
  age: string;
  incidentId: number;
  incidentCountry: string;
  incidentCity: string;
  cause: string;
  assignment: string;
  acStatus: string;
  channelType: ChannelType;
  countryCode: string;
  incidentTimeZone: number;
  currentTimeZone: number;
  caseCreatedDate: Date | null;
  caseCreatedDateAsISOString: string;
  lastHandled: Date | null;
  timeSpendInMinutes: number;
  phoneConversation: PhoneConversation[];
  insuranceCheckTime: Date | null;
  insuranceCheckMethod: string;
  insuranceCheckUser: string;
  privacyNoticeTime: Date | null;
  privacyNoticeChannel: string;
  privacyNoticeSendTo: string;
  caseClosedTime: Date | null;
  caseClosedHandler: string;
  caseNumber: string;
  caseStakeholders: CaseStakeholder[];
  simpleCaseStakeholders: SimpleCaseStakeholder[];
  incident: SimpleIncident;
  enduserId: string;
  policyHolderId: string;
  reporterId: string;
  caseScreening: CaseScreening;
  customerProfileId: number;
  handlingAreas: HandlingArea[];

  public constructor(init?: Partial<Case>) {
    Object.assign(this, init);
  }

  public static extractStakeholderName(case1: Case, stakeholderType: StakeholderTypeEnum): string | null {
    let name: string | null = null;

    case1.caseStakeholders.forEach(stakeHolder => {
      if (stakeHolder.stakeholderType === stakeholderType.toString()) {
        case1.simpleCaseStakeholders.forEach(simpleStakeHolder => {
          if (simpleStakeHolder.id === stakeHolder.stakeholderId) {
            name = simpleStakeHolder.firstName + ' ' + simpleStakeHolder.surname;
          }
        });
      }
    });

    return name;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CaseAdapter implements Adapter<Case> {
  constructor(private userAdapter: UserAdapter, private handlingAreaAdapter: HandlingAreaAdapter) {}

  adapt(item: any): Case {
    return new Case({
      team: '', // Is not used yet, it will become the product team later.
      cu: item.cu,
      product: item.product,
      id: item.id,
      endUserName: item.endUserName,
      sex: item.sex,
      age: item.age,
      incidentId: item.incidentId,
      incidentCountry: item.incidentCountry,
      incidentCity: item.incidentCity,
      cause: item.cause,
      assignment: item.assignee,
      acStatus: item.acStatus,
      channelType: item.channelType,
      countryCode: item.countryCode,
      incidentTimeZone: item.incidentTimezone,
      currentTimeZone: item.currentTimezone,
      caseCreatedDate: item.caseCreatedDate === '' ? null : new Date(item.caseCreatedDate),
      caseCreatedDateAsISOString: item.caseCreatedDateAsISOString,
      lastHandled: item.lastHandled === '' ? null : new Date(item.lastHandled),
      timeSpendInMinutes: item.timeSpendInMinutes,
      phoneConversation: item.phoneConversation,
      insuranceCheckTime: item.insuranceCheckTime === '' ? null : new Date(item.insuranceCheckTime),
      insuranceCheckMethod: item.insuranceCheckMethod,
      insuranceCheckUser: item.insuranceCheckUser,
      privacyNoticeTime: item.privacyNoticeTime === '' ? null : new Date(item.privacyNoticeTime),
      privacyNoticeChannel: item.privacyNoticeChannel,
      privacyNoticeSendTo: item.privacyNoticeSendTo,
      caseClosedTime: item.caseClosedTime === '' ? null : new Date(item.caseClosedTime),
      caseClosedHandler: item.caseClosedHandler,
      caseNumber: item.caseNumber,
      caseStakeholders: item.caseStakeholders,
      simpleCaseStakeholders: item.stakeholders,
      incident: item.incident,
      enduserId: item.enduserId,
      policyHolderId: item.policyHolderId,
      reporterId: item.reporterId,
      caseScreening: item.caseScreening,
      handlingAreas: item.handlingAreas.map((handlingAreaItem: any) => this.handlingAreaAdapter.adapt(handlingAreaItem))
    });
  }
}
